import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import SelectDialog from 'FDComponents/constants/Dialog';
import ContentAdd from '@material-ui/icons/Add';

import SponsorsPanels from '../../../personSponsors/Panels';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import { UserRestriction } from '../../../../common/components/UserRestiction';

const styles = {
  icon: {
    marginRight: 8,
  },
};

@injectIntl
@withStyles(styles)
export default class Sponsors extends Component {
  render() {
    const {
      sponsors,
      classes,
      onAdd,
      intl: { messages: m },
    } = this.props;

    return (
      <div>
        <Toolbar>
          <Typography variant="h6">{m.app_sponsors}</Typography>
          <div style={{ flex: 1 }} />
          <UserRestriction>
            <SelectDialog
              title={m.dialog_addSponsor}
              form="sponsor_select"
              onCreate={onAdd}
              entity="personSponsor"
            >
              <Button variant="contained" color="primary">
                <ContentAdd className={classes.icon} />
                {m.button_add}
              </Button>
            </SelectDialog>
          </UserRestriction>
        </Toolbar>
        <div style={{ padding: 16 }}>
          <SponsorsPanels sponsors={sponsors} />
        </div>
      </div>
    );
  }
}
